<template lang="pug">
div.animated.fadeIn
  // conclusion by duration
  b-card
    div.row
      div.col-sm-4
      div.col-sm-8
        div.dateRangePickerContainer
          i(class="fa fa-calendar")
          date-range-picker.ml-2.dateRangePicker(ref="ref" :options="options")
          i(class="fa fa-caret-down")
    br
    div(id='graphContainer' style='height: 800px')
</template>

<script>
// import { db } from '@/firebase'
import echarts from 'echarts'
import $ from 'jquery'
var moment = require('moment')
// const anaRef = db.ref('analytics')

export default {
  name: 'dashboard',
  data() {
    return {
      initialise: true,
      userAccessLevel: this.$store.state.profile.accessLevel,
      // for date range picker
      options: {
        startDate: moment().subtract(29, 'days'),
        endDate: moment(),
        locale: {
          format: 'DD/MM/YYYY',
        },
        ranges: {
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        },
      },
      yAxisLabels: [],
      sliderEndPoint: '',
      sliderStartPoint: '',
      option: null,
    }
  },
  mounted: function() {
    const el = $(this.$refs.ref.$el)
    el.on('apply.daterangepicker', (event, picker) => {
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      this.sliderEndPoint = `${picker.endDate.format('L').substring(3, 5)} ${monthNames[parseInt(picker.endDate.format('L').substring(0, 2)) - 1]}`
      this.sliderStartPoint = `${picker.startDate.format('L').substring(3, 5)} ${monthNames[parseInt(picker.startDate.format('L').substring(0, 2)) - 1]}`
      this.setOption(this.sliderEndPoint, this.sliderStartPoint, this.yAxisLabels, this.numberOfTotal, this.numberOfAgent, this.numberOfBot, this.numberOfUser)
      let sliderStartTime = new Date(picker.startDate.format('L'))
      let sliderEndTime = new Date(picker.endDate.format('L'))
      let dataStartTime = new Date(`${this.yAxisLabels[0]} 2019`)
      let dataEndTime = new Date(`${this.yAxisLabels[this.yAxisLabels.length - 1]} 2019`)
      if (sliderStartTime < dataStartTime) {
        this.sliderStartPoint = this.yAxisLabels[0]
      }
      if (sliderEndTime > dataEndTime) {
        this.sliderEndPoint = this.yAxisLabels[this.yAxisLabels.length - 1]
      }
      this.setOption(this.sliderEndPoint, this.sliderStartPoint, this.yAxisLabels, this.numberOfTotal, this.numberOfAgent, this.numberOfBot, this.numberOfUser)
      var dom = document.getElementById('graphContainer')
      var myChart = echarts.init(dom)
      myChart.setOption(this.option, true)
    })
    this.getGraph()
  },
  methods: {
    getGraph() {
      this.loadRealData = true
      var dom = document.getElementById('graphContainer')
      var myChart = echarts.init(dom)
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      let yAxisLabels = []
      let numberOfTotal = []
      let numberOfAgent = []
      let numberOfBot = []
      let numberOfUser = []
      let lastDay = ''
      var year = 2019
      // sample data
      const todayDate = new Date()
      var date = +echarts.number.parseDate(year + '-01-01')
      var end = +echarts.number.parseDate(`${year}-${todayDate.getMonth() + 1}-${todayDate.getDate()}`)
      var dayTime = 3600 * 24 * 1000
      // var data = []
      for (var time = date; time < end; time += dayTime) {
        var dateString = echarts.format.formatTime('yyyy-MM-dd', time)
        lastDay = `${dateString.substring(8)} ${monthNames[parseInt(dateString.substring(5, 7)) - 1]}`
        yAxisLabels.push(lastDay)
        let agentNumber = Math.floor(Math.random() * 100)
        let botNumber = Math.floor(Math.random() * 1000)
        let userNumber = Math.floor(Math.random() * 1000)
        numberOfTotal.push(agentNumber + botNumber + userNumber)
        numberOfAgent.push(agentNumber)
        numberOfBot.push(botNumber)
        numberOfUser.push(userNumber)
      }
      this.sliderEndPoint = lastDay
      this.sliderStartPoint = yAxisLabels[yAxisLabels.length - 30]
      this.yAxisLabels = yAxisLabels
      this.numberOfTotal = numberOfTotal
      this.numberOfAgent = numberOfAgent
      this.numberOfBot = numberOfBot
      this.numberOfUser = numberOfUser
      this.initialise = false
      this.setOption(this.sliderEndPoint, this.sliderStartPoint, this.yAxisLabels, this.numberOfTotal, this.numberOfAgent, this.numberOfBot, this.numberOfUser)
      if (this.option && typeof this.option === 'object') {
        myChart.setOption(this.option, true)
      }
    },
    setOption(sliderEndPoint, sliderStartPoint, yAxisLabels, numberOfTotal, numberOfAgent, numberOfBot, numberOfUser) {
      this.option = {
        backgroundColor: '#fff',
        animation: false,
        title: {
          top: 5,
          left: 5,
          text: 'Interactions Timeline',
        },
        legend: {
          top: 10,
          right: 100,
          data: ['Total', 'Visitors', 'Bot', 'Agent'],
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            animation: false,
            shadowStyle: {color: 'rgba(50,181,217,0.1)'},
          },
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          transitionDuration: 0.1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {
            color: '#000',
          },
        },
        axisPointer: {
          link: {
            xAxisIndex: 'all',
          },
          label: {
            backgroundColor: '#777',
          },
        },
        toolbox: {
          orient: 'vertical',
          top: 5,
          right: 20,
          showTitle: false,
          feature: {
            dataZoom: {
              yAxisIndex: false,
              show: false,
            },
            restore: {},
            saveAsImage: {},
          },
        },
        grid: [
          {
            left: '10%',
            right: '8%',
            height: '50%',
          },
          {
            left: '10%',
            right: '8%',
            top: '66%',
            height: '16%',
          },
        ],
        xAxis: [
          {
            type: 'category',
            data: yAxisLabels,
            scale: true,
            boundaryGap: true,
            axisLine: {
              onZero: false,
            },
            splitLine: {show: true},
            splitNumber: 20,
            min: 'dataMin',
            max: 'dataMax',
            axisPointer: {
              z: 100,
            },
          },
          {
            type: 'category',
            gridIndex: 1,
            data: yAxisLabels,
            scale: true,
            boundaryGap: true,
            axisLine: {onZero: false},
            axisTick: {show: false},
            splitLine: {show: false},
            axisLabel: {show: false},
            splitNumber: 20,
            min: 'dataMin',
            max: 'dataMax',
          },
        ],
        yAxis: [
          {
            scale: true,
            splitArea: {
              show: true,
            },
          },
          {
            scale: true,
            gridIndex: 1,
            splitNumber: 2,
            axisLabel: {show: false},
            axisLine: {show: false},
            axisTick: {show: false},
            splitLine: {show: false},
          },
        ],
        dataZoom: [
          {
            type: 'inside',
            xAxisIndex: [0, 1],
            startValue: sliderStartPoint,
            endValue: sliderEndPoint,
          },
          {
            show: true,
            smooth: true,
            xAxisIndex: [0, 1],
            type: 'slider',
            top: '85%',
            startValue: sliderStartPoint,
            endValue: sliderEndPoint,
          },
        ],
        series: [
          {
            name: 'Total',
            type: 'line',
            symbol: 'circle',
            barGap: 0,
            symbolSize: 8,
            step: 'middle',
            smooth: false,
            color: '#32b5d9',
            data: numberOfTotal,
            label: {
              normal: {
                show: true,
                color: '#fff',
                position: 'top',
                padding: 2,
                borderRadius: 4,
                backgroundColor: '#32b5d9',
              },
            },
            lineStyle: {
              type: 'dotted',
              color: '#999',
            },
          },
          {
            name: 'Visitors',
            type: 'bar',
            barGap: 0,
            symbol: 'circle',
            symbolSize: 8,
            color: '#6fdebd',
            data: numberOfUser,
            smooth: false,
            lineStyle: {
              color: '#6fdebd',
            },
            label: {
              normal: {
                show: true,
                color: '#6fdebd',
                position: 'top',
              },
            },
          },
          {
            name: 'Bot',
            barGap: 0,
            type: 'bar',
            symbol: 'circle',
            symbolSize: 8,
            color: '#ffb994',
            data: numberOfBot,
            smooth: false,
            lineStyle: {
              color: '#ffb994',
            },
            label: {
              normal: {
                show: true,
                color: '#ffb994',
                position: 'top',
              },
            },
          },
          {
            name: 'Agent',
            type: 'bar',
            symbol: 'circle',
            symbolSize: 8,
            color: '#afb2e3',
            data: numberOfAgent,
            smooth: false,
            lineStyle: {
              color: '#afb2e3',
            },
            label: {
              normal: {
                show: true,
                color: '#afb2e3',
                position: 'top',
              },
            },
          },
          {
            name: 'Visitors',
            type: 'bar',
            color: '#6fdebd',
            label: {
              normal: {
                show: true,
                position: 'top',
              },
            },
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: numberOfUser,
          },
        ],
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Analytics/InteractionsTimeline.vue?021cfe7f